import React from "react";

export default function SpinLoader() {
  return (
    <div className="flex flex-1 items-center justify-center py-12">
      <div
        className="h-16 w-16 rounded-full border-8 border-gray-200 border-t-brand-orange animate-spin"
        aria-label="Loading"
      />
    </div>
  );
}
